import type { BoardRect } from '../selection/utils/selectionGeometry';

export interface BoardRenderWindow extends BoardRect {}

export const boardRenderOverscan = 1000;

export function getBoardRenderWindow(visibleRect: BoardRect | null): BoardRenderWindow {
  if (!visibleRect) {
    return {
      height: window.innerHeight + boardRenderOverscan * 2,
      width: window.innerWidth + boardRenderOverscan * 2,
      x: 0,
      y: 0,
    };
  }

  const x = Math.max(0, visibleRect.x - boardRenderOverscan);
  const y = Math.max(0, visibleRect.y - boardRenderOverscan);
  const maxWidth = visibleRect.width + boardRenderOverscan * 2;
  const maxHeight = visibleRect.height + boardRenderOverscan * 2;

  return {
    height: maxHeight,
    width: maxWidth,
    x,
    y,
  };
}

export function rectsIntersect(
  first: { height: number; width: number; x: number; y: number },
  second: { height: number; width: number; x: number; y: number }
) {
  return (
    first.x < second.x + second.width &&
    first.x + first.width > second.x &&
    first.y < second.y + second.height &&
    first.y + first.height > second.y
  );
}
